import React from 'react'
// libs
import styled from 'styled-components'
import { useDispatch } from 'react-redux'
import { useMutation } from '@apollo/client/react'
// components
import { IconButton } from 'components/UI'
// icons
import UnarchiveIconOrigin from '@mui/icons-material/Unarchive'
// context
import { RiskTemplateAPIContext } from 'containers/Risks/RiskTemplate/Edit/layers/API'
// store
import { updateRiskTemplate } from 'store/reducers/riskTemplates'
// graphql
import { RISK_TEMPLATE_UPDATE_MUTATION } from 'graphql/risk/mutations'
// utils
import { size } from 'polished'
import { handleError } from 'utils/errors/handlers'

const UnarchiveIcon = styled(UnarchiveIconOrigin)`
  && {
    ${size('24px')};
  }
`

const UnarchiveTemplateButton: React.FC = () => {
  const dispatch = useDispatch()

  const [riskTemplateUpdateMutation] = useMutation(RISK_TEMPLATE_UPDATE_MUTATION)

  const { riskTemplate, refetchTemplate } = React.useContext(RiskTemplateAPIContext)

  const unarchiveTemplate = () => {
    try {
      riskTemplateUpdateMutation({
        variables: {
          id: riskTemplate.id,
          input: { archived: false }
        }
      }).then(() => refetchTemplate())

      dispatch(updateRiskTemplate({ id: riskTemplate.id, data: { archived: false } }))
    } catch (e) {
      handleError(e, 'UnarchiveTemplateButton.unarchiveTemplate')
    }
  }

  return (
    <IconButton description='Unarchive Template' onClick={unarchiveTemplate}>
      <UnarchiveIcon color='inherit' />
    </IconButton>
  )
}

export default UnarchiveTemplateButton
